<ds-card-header
    title="{{ backgroundContainerConfig.showTitle ? title : '' }}"
    msThemedCardHeader
    surface="lowest"
    [themedSurface]="themeHeaderSurface">
    @if (isRequiredTitleIcon()) {
        <span slot="start">
            @if (checkTitleIcon) {
                <ms-competition-logo class="icon" [sportId]="titleIcon?.sportId" [leagueId]="titleIcon.id" [fallbackIcon]="titleIcon?.icon" />
            } @else if (titleIcon?.icon) {
                <vn-icon size="13" [name]="titleIcon.icon ?? ''" />
            }
        </span>
    }
    @if (globalLinkConfig.visible && globalLink && globalLinkText) {
        <button slot="end" ds-button size="small" variant="flat-reduced" kind="tertiary" (click)="linkClick()">
            {{ globalLinkText }} <vn-icon slot="end" name="theme-right" class="right-icon" size="12" />
        </button>
    }
</ds-card-header>
